<template>
  <b-dropdown-group id="dropdown-group-3" header="Orders List Actions">
    <b-dropdown-item href="#" @click.prevent="openModal">Send Custom Mail & SMS</b-dropdown-item>
</b-dropdown-group>
</template>

<script>
import EventBus from '../../../../EventBus';

  export default {
      methods: {
        openModal(){ 
          EventBus.$emit('show-custom-notification-modal')
        }
      }
  }
</script>

<style lang="scss" scoped>

</style>